import { Controller, useFormContext } from 'react-hook-form';
import { Checkbox, Divider, FormControlLabel, FormGroup } from '@hopskipdrive/react-components';

export const FormPreferenceOptions = () => {
  const { control } = useFormContext();

  return (
    <>
      <Divider />
      <FormGroup row>
        <Controller
          name="favorite"
          control={control}
          render={({ field: { onChange, value } }) => (
            <FormControlLabel
              control={
                <Checkbox
                  sx={{ ml: '.5rem' }}
                  id="asFavorite"
                  data-testid="asFavorite"
                  checked={value}
                  onChange={(e) => {
                    onChange(e.target.checked);
                  }}
                />
              }
              label="Mark as favorite"
            />
          )}
        />
        <Controller
          name="default"
          control={control}
          render={({ field: { onChange, value } }) => (
            <FormControlLabel
              control={
                <Checkbox
                  sx={{ ml: '.5rem' }}
                  id="asDefault"
                  data-testid="asDefault"
                  checked={value}
                  onChange={(e) => {
                    onChange(e.target.checked);
                  }}
                />
              }
              label="Use this view as default"
            />
          )}
        />
      </FormGroup>
    </>
  );
};
